<template>
  <v-card class="rounded-lg">
    <v-data-table
      :headers="headers"
      :items="actions"
      sort-by="position"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Feedback actions list</v-toolbar-title>
          <v-spacer />
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Action</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Action name"
                        filled
                        v-validate="{
                          required: true
                        }"
                        name="name"
                        :error-messages="errors.collect('name')"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.default="{ item }">
        <v-checkbox
          :input-value="item.default"
          label="use as default"
          @change="(e) => setDefault({ ...item, default: e })"
          dense
        />
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          small
          icon
          @click="editItem(item)"
        >
          <v-icon
            small
          >
            {{ mdiPencil }}
          </v-icon>
        </v-btn>
        <v-btn
          small
          icon
          @click="delItem(item)"
        >
          <v-icon
            small
          >
            {{ mdiDelete }}
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <delete-dialog
      v-if="deleteDialog"
      :item="deletedItem"
      @close="deleteDialog = false"
      @confirm="deleteItem"
    />
  </v-card>
</template>

<script>
import { mdiPencil, mdiDelete } from "@mdi/js"
export default {
  components: {
    deleteDialog: () => import('@/components/dialogs/DeleteDialog.vue'),
  },
  data: () => ({
    mdiPencil,
    mdiDelete,
    dialog: false,
    deleteDialog: false,
    actions: [],
    headers: [
      {
        text: 'Name',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'action',
        align: 'center',
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {
      name: ''
    },
    defaultItem: {
      name: ''
    },
    deletedItem: null
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Action' : 'Edit Action';
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  async mounted () {
    this.getActions()
  },
  methods: {
    async getActions () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/feedback/actions`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.actions = data
      }
    },
    editItem(item) {
      this.editedIndex = this.actions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    delItem (item) {
      this.deletedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async deleteItem(item) {
      const { data } = await this.$axios.delete(
        `${this.$store.getters.projectPath}/feedback/actions/${item.id}`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.$toasted.success('Action removed')
        const index = this.actions.findIndex(action => action.id === item.id)
        this.$delete(this.actions, index)
      }

      this.deletedItem = null
      this.deleteDialog = false
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save() {
      this.$validator.validateAll().then(async res => {
        if (res) {
          if (this.editedIndex > -1) {
            const { data } = await this.$axios.put(
              `${this.$store.getters.projectPath}/feedback/actions/${this.editedItem.id}`, {
                ...this.editedItem
              }
            ).catch(error => ({ data: { err: true, message: error.response.data } }))

            if (data.err) {
              this.$toasted.error(data.message)
            } else {
              this.$toasted.success('Action updated')
            }
          } else {
            const { data } = await this.$axios.post(
              `${this.$store.getters.projectPath}/feedback/actions`, {
                ...this.editedItem
              }
            ).catch(error => ({ data: { err: true, message: error.response.data } }))

            if (data.err) {
              this.$toasted.error(data.message)
            } else {
              this.$toasted.success('Action created')
              this.actions.push({...this.editedItem, ...data })
            }
          }
          this.close()
        }
      })
    },
  },
}
</script>
